import {Component} from "@angular/core"
import {Router} from "@angular/router";
import {FormBuilder, Validators} from "@angular/forms";
import {first} from "rxjs/operators";

import {SessionManagerService} from "src/app/services/session-manager.service"
import {ViewManagerService} from "../../services/view-manager.service";
import {Level, Message} from "../../model/message.component";

@Component({
  templateUrl: "./signin.component.html",
  styleUrls: ["./signin.component.css"]
})
export class SigninComponent {

  form = this.formBuilder.group({
    username: ["frc.api@finregcloud.net", [Validators.required, Validators.email]],
    password: ["1234567", [Validators.required, Validators.minLength(7)]]
  });

  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sessionManager: SessionManagerService,
    private viewManager: ViewManagerService
  ) {
  }

  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    let username = this.f.username.value ?? ""
    let password = this.f.password.value ?? ""

    this.sessionManager.login(username, password)
      .pipe(first())
      .subscribe({
        next: (session) => {
          console.log("login successful for", session.username);
          this.viewManager.setFrontends(session.frontends)
          this.viewManager.displayMessage(new Message("login successful", new Level("info")))
          this.router.navigate(["admin/dashboard"]);
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }
}
